<template>
  <div class="nuttrema-calivi-list">
    <nuttrema-layout-three-vertical>

      <div slot="top" class="nuttrema-calivi-list__header">
        <span class="header__date" @click="$emit('change-date')">{{ date | moment('dddd DD, MMMM') }}</span>
        <span class="header__today" v-if="isToday">{{ $t('label.today') }}</span>
      </div>

      <div slot="middle" class="nuttrema-calivi-list__content">
        <!-- <nuttrema-loader v-if="true"></nuttrema-loader> -->
        <nuttrema-loader v-if="ScheduledDateSchedules.fetching"></nuttrema-loader>

          <!-- class="with-logo is-transparent in-east-block is-zero-z is-pull-5em"
          icon="fal fa-calendar-exclamation"> -->
        <nuttrema-empty-result
          v-else-if="_isEmpty(_get(ScheduledDateSchedules, 'data', []))"
          theme="default"
          class="with-logo in-east-block is-zero-z is-pull-5em"
          predefined-set="landscape">
          <div slot="text">
            <h1>{{ $t('label.result_is_empty') }}</h1>
            <h4>{{ $t('label.there_seems_to_be_no_schedule') }}...</h4>
          </div>
        </nuttrema-empty-result>

        <div class="content-list">
          <template v-for="time in _get(ScheduledDateSchedules, 'data', [])">

            <template v-for="(schedule, index) in _get(time, 'Schedules', [])">

              <template v-if="_get(schedule, 'Children', []).length === 0">
                <div
                  class="content-list__schedule" :key="_get(schedule, 'id')">
                    <div class="content-list__schedule__time">
                      <span v-if="index === 0">{{ _get(time, 'Time') | format-time }}</span>
                    </div>
                    <div class="content-list__schedule__dot">
                      <nuttrema-dot-kcal :nutrientDefinition="_get(schedule, 'NutritionInfo')" :grams="_get(schedule, 'quantity_gr') | number-format(2)"></nuttrema-dot-kcal>
                    </div>
                    <div class="content-list__schedule__description" @click="handleActionClick(_get(schedule, 'id'))">
                      <div class="description__quantity">
                        <nuttrema-stuff-to-eat-quantity
                          :amount="_get(schedule, 'amount', 0)"
                          :servingSizeTitle="_get(schedule, 'EntityServingSize.title')"
                          :quantityGr="_get(schedule, 'quantity_gr', 0)"
                          :symbol="_get(schedule, 'EntityServingSize.symbol')">
                        </nuttrema-stuff-to-eat-quantity>
                      </div>
                      <div class="description__name">{{ _get(schedule, 'title') || _get(schedule, 'Entity.name') }}</div>
                      <div class="description__category">{{ _get(schedule, 'EntityTypeCategory.name') }}</div>
                    </div>
                    <div class="content-list__schedule__action" @click="handleActionClick(_get(schedule, 'id'))">
                      <i class="far fa-angle-right"></i>
                    </div>
                </div>
              </template>

              <template v-else>
                <template v-for="(children, index) in _get(schedule, 'Children', [])">
                  <div
                  class="content-list__schedule is-child" :key="_get(children, 'id')">
                    <div class="content-list__schedule__time">
                      <span v-if="index === 0">{{ _get(time, 'Time') | format-time }}</span>
                    </div>
                    <div class="content-list__schedule__dot">
                        <nuttrema-dot-kcal :nutrientDefinition="_get(children, 'NutritionInfo')" :grams="_get(children, 'quantity_gr') | number-format(2)"></nuttrema-dot-kcal>
                    </div>
                    <div class="content-list__schedule__description" @click="handleActionClick(_get(schedule, 'id'), _get(children, 'id'))">
                      <div class="description__quantity">
                        <nuttrema-stuff-to-eat-quantity
                          :amount="_get(children, 'amount', 0)"
                          :servingSizeTitle="_get(children, 'EntityServingSize.title')"
                          :quantityGr="_get(children, 'quantity_gr', 0)"
                          :symbol="_get(children, 'EntityServingSize.symbol')">
                        </nuttrema-stuff-to-eat-quantity>
                      </div>
                      <div class="description__name">{{ _get(children, 'title') || _get(children, 'Entity.name') }}</div>
                      <div class="description__category">{{ _get(children, 'EntityTypeCategory.name') }}</div>
                    </div>
                    <div class="content-list__schedule__action" @click="handleActionClick(_get(schedule, 'id'), _get(children, 'id'))">
                      <i class="far fa-angle-right"></i>
                    </div>
                </div>
                </template>
              </template>


            </template>
          </template>
        </div>

      </div>
    </nuttrema-layout-three-vertical>

  </div>
</template>

<script>
import moment from 'moment';
import NuttremaLayoutThreeVertical from 'components/ui/layout/nuttrema-layout-three-vertical';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

import NuttremaDotKcal from 'components/ui/label/nuttrema-dot-kcal';
import NuttremaStuffToEatQuantity from 'components/ui/label/nuttrema-stuff-to-eat-quantity';

export default {
  name: 'nuttrema-calivi-list',
  props: {
    date: {
      type: Date,
      required: false,
      default: null,
    },
    ScheduledDateSchedules: {
      type: Object,
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLoader,
    NuttremaDotKcal,
    NuttremaEmptyResult,
    NuttremaStuffToEatQuantity,
    NuttremaLayoutThreeVertical,
  },
  computed: {
    isToday() {
      return moment(this.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');
    },
  },
  methods: {
    handleActionClick(id, refID) {
      this.$emit('view-schedule-detail', id, refID);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/theme/colors';

$border-color: rgba($gray, 0.15);
$header-text-color: rgba($gray, 0.6);

.nuttrema-calivi-list {
  display: flex;
  flex-grow: 1;
  height: 100%;
  position: relative;
  align-self: stretch;
  flex-direction: column;
  padding-bottom: 3em;

  .nuttrema-calivi-list__header {
    flex-grow: 1;
    display: flex;
    margin-left: 1em;
    padding: 0.5em 0;
    align-self: stretch;
    color: $header-text-color;
    justify-content: space-between;
    border-bottom: 1px solid $border-color;

    .header__date {
      font-size: 0.9rem;
      font-weight: 500;
      &:hover {
        cursor: pointer;
      }
    }

    .header__today {
      font-weight: 500;
      margin-right: 1em;
      font-size: 0.85rem;
      text-transform: uppercase;
    }
  }

  .nuttrema-calivi-list__content {
    display: flex;
    flex-grow: 1;
    align-self: stretch;

    .content-list {
      flex-grow: 1;
      display: flex;
      margin-left: 1em;
      font-size: 0.9rem;
      align-self: stretch;
      flex-direction: column;

      .content-list__schedule {
        display: flex;
        flex-shrink: 0;
        align-self: stretch;
        justify-content: space-between;
        border-bottom: 1px solid $border-color;

        > * {
          padding: 0.5em 0;
        }

        .content-list__schedule__time {
          display: flex;
          min-width: 2.5em;
          font-weight: 600;
          margin-right: 0.5em;
          color: $header-text-color;
        }

        .content-list__schedule__dot {
          display: flex;
          padding-right: 0.5em;
        }

        .content-list__schedule__description {
          display: flex;
          flex-grow: 1;
          padding-right: 0.5em;
          flex-direction: column;
          .description__name {
            font-weight: 500;
          }
          .description__quantity {
            font-size: 0.85rem;
            line-height: 1.55;
          }
          .description__category {
            font-size: 0.85rem;
          }
          &:hover {
            cursor: pointer;
          }
        }

        .content-list__schedule__action {
          display: flex;
          width: 10em;
          align-items: center;
          padding: 0 1.5em 0 1em;
          justify-content: flex-end;
          i {
            color: #898989;
            font-size: 1.5rem;
          }
          &:hover {
            cursor: pointer;
          }
        }

        &.is-child {
          border-bottom: none;
          .content-list__schedule__dot,
          .content-list__schedule__description,
          .content-list__schedule__action {
            border-bottom: 1px solid $border-color;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/schedules/nuttrema-calivi-list.vue